import { render, staticRenderFns } from "./categorias.select.checkbox.vue?vue&type=template&id=150090e0&scoped=true&"
import script from "./categorias.select.checkbox.vue?vue&type=script&lang=js&"
export * from "./categorias.select.checkbox.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../frontend-new/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "150090e0",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../frontend-new/node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCheckbox } from 'vuetify/lib/components/VCheckbox';
installComponents(component, {VCheckbox})
